/**
 * Shared helpers for QR sticker printing.
 *
 * Label sizes are fixed presets: three portable sticker-printer rolls
 * (a Niimbot B21 and friends print 50×30 / 40×30 / 30×20 mm) and two
 * A4 sheet sizes. The PDF is produced server-side at exact millimetre
 * dimensions so nothing depends on browser print scaling.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LABEL_PRESETS = [
  { value: '50x30', label: '50 × 30 mm — sticker roll', sticker: true },
  { value: '40x30', label: '40 × 30 mm — sticker roll', sticker: true },
  { value: '30x20', label: '30 × 20 mm — small sticker', sticker: true },
  { value: '70x37', label: '70 × 37 mm — A4 sheet', sticker: false },
  { value: '100x70', label: '100 × 70 mm — large label', sticker: false },
];

export const presetMm = (preset) => {
  const [w, h] = preset.split('x').map(Number);
  return { w, h };
};

/** How many of this sticker fit on one A4 sheet (8 mm margins, 2 mm gutter). */
export const sheetCapacity = (preset) => {
  const { w, h } = presetMm(preset);
  const gap = 2;
  const cols = Math.max(1, Math.floor((210 - 16 + gap) / (w + gap)));
  const rows = Math.max(1, Math.floor((297 - 16 + gap) / (h + gap)));
  return { cols, rows, total: cols * rows };
};

export async function fetchLabelPng({ kind, id, preset, logo = true, dpi = 300 }) {
  const { w, h } = presetMm(preset);
  const r = await axios.get(`${API}/qr/${kind}/${id}/label.png`, {
    params: { w_mm: w, h_mm: h, dpi, logo },
    responseType: 'blob',
  });
  return r.data;
}

const openBlob = (blob, filename, download) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  if (download) a.download = filename;
  else a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
};

export async function downloadLabelPng({ kind, id, preset, code, logo = true, dpi = 300 }) {
  const blob = await fetchLabelPng({ kind, id, preset, logo, dpi });
  openBlob(blob, `label_${(code || kind).replace(/[^\w-]+/g, '_')}_${preset}.png`, true);
}

export async function openLabelsPdf({ kind, ids, preset, layout = 'sheet', logo = true, copies = 1 }) {
  const r = await axios.get(`${API}/qr/labels.pdf`, {
    params: { kind, ids: ids.join(','), preset, layout, logo, copies },
    responseType: 'blob',
  });
  openBlob(r.data, `labels_${kind}_${preset}.pdf`, false);
}
